import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import {ImUser} from 'react-icons/im';
import {Avatar} from 'antd';
import {getFromSource} from '../../utils/getImages';

export const EMPTY_AVATAR_VIEW = {
  INITIALS: 'INITIALS',
  DEFAULT: 'DEFAULT'
};

const UserAvatar = ({user, src, emptyAvatarView, ...props}) => {
  const {avatar, avatarOriginal} = user;

  const userAvatar = useMemo(() => src || avatar || avatarOriginal, [src, avatar, avatarOriginal]);

  return (
    <Avatar
      src={getFromSource(userAvatar)}
      icon={!userAvatar && emptyAvatarView === EMPTY_AVATAR_VIEW.DEFAULT && <ImUser/>}
      {...props}
    >
      {!userAvatar && emptyAvatarView === EMPTY_AVATAR_VIEW.INITIALS && user?.firstName}
    </Avatar>
  );
};

export default memo(UserAvatar);

UserAvatar.propTypes = {
  user: PropTypes.object,
  src: PropTypes.string,
  emptyAvatarView: PropTypes.string,
};

UserAvatar.defaultProps = {
  user: {},
  emptyAvatarView: EMPTY_AVATAR_VIEW.DEFAULT,
};
